<template>
<div>
  <!-- <Modal v-model="modal" title="继任者空岗" width="88%" :closable='false' :mask-closable="false"> -->
    <Form :model="modalFormItem" :label-width="130" label-position="left">
      <Row :gutter="10">
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('PB_Vacancies_Position')"><!-- 空岗职位 -->
            <Input v-model="modalFormItem.jobName" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Band')"><!-- Band -->
           <Select v-model="modalFormItem.hcmBand" clearable>
                    <Option v-for="item in Band" :value="item.ch_value" :key="item.code" >{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                </Select>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Position_Title_Chinese')"><!-- 职务描述（中文） -->
            <Input v-model="modalFormItem.positionCTitle" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Position_Title_English')"><!-- 职务描述（英文） -->
            <Input v-model="modalFormItem.positionETitle" />
            <!-- <Select v-model="modalFormItem.position" clearable style="width:100%">
              <Option v-for="item in positionList" :value="item.ch_value" :key="item.code">{{item.ch_value}}</Option>
            </Select> -->
          </FormItem>
        </Col>
        <Col  :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Position')">
            <Input type="text" v-model="modalFormItem.position" />
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="4">
          <Button @click="pageInfo.pageNo=1,getData()"><!-- 检 索 -->{{$t('Search')}}</Button>
          <Button @click="handleReset()"><!-- 清空检索 -->{{$t('PB_Clear')}}</Button>
        </Col>
        
      </Row>
    </Form>
    <div style="display: flex; align-items: center;justify-content: space-between;margin-bottom:10px">
        <div>
            <span><!-- 空岗合计 -->{{$t('PB_Total_No_User')}}：{{nullJobNum}}</span>
            <!-- <span style="margin-left:20px" v-if="btnShow">空岗合计：{{nullJobNum}}个</span> -->
        </div>
        <Button type="text" @click="addJob" :disabled="beEnd==1"><!-- 新增空岗 -->{{$t('PB_Add')}}</Button> 
    </div>
    <Table border :columns="modelColumns" :data="modelData"
    ref="selectiona" :loading="loading">
    <template slot="action1" slot-scope="{ row, index }">
        <Button type="warning" size="small" :disabled="beEnd==1" style="margin-right: 8px" @click="editItem(row, index)"><!-- 编辑 -->{{$t('Edit')}}</Button>
        <Button type="error" size="small" :disabled="beEnd==1" @click="deleteItem(row, index)"><!-- 删除 -->{{$t('Delete')}}</Button>
      </template>
    </Table>
    
    <div style="display: flex;justify-content: end;margin-top: 30px;">
      <Page :total="total" @on-change="pageChange" :page-size="pageInfo.pageSize" transfer :page-size-opts="[10,50,100,150]" show-sizer @on-page-size-change="pageSizeChange" :current="pageInfo.pageNo"></Page>
    </div>

    
  <!-- </Modal> -->
    <JobModal ref="JobModal" @jobSave="jobSave" @jobEdit="jobEdit"></JobModal>
  </div>
</template>

<script>
import axios from 'axios'
import EventBus from '@/util/eventBus.js'
import JobModal from "./JobModal";
export default {
  components:{JobModal},
  data() {
    return {
        loading:false,
        modal: false,
        modalFormItem: {},
        
        modelData: [],
        pageInfo: {
            itemCount: 0,
            pageNo: 1,
            pageSize: 150,
        },
        total: 0,
        list:[],
        yesOrNo:[],
        businessUnitList:[],
        departmentList:[],
        functionList:[],
        Band:[],
        state:false,
        rowItem:{},
        targetkey:'',
        userType:'',
        id:'',
        nullJobNum:0,
        btnShow:false,
        beEnd:'',
        index:'',
        jobselectList:[],
    };
  },
  computed:{
    modelColumns(){
        return [
        //  {
        //     title: this.$t('Be_People_Manager'),/* 空岗是否顶层 */
        //     key: "beTopLevel",
        //     align: "center",
        //     minWidth: 200,
        //     render: (h, params) => {
        //         return h(
        //         "span",
        //         this.yesOrNo &&
        //             this.yesOrNo.filter(
        //             item => params.row.beTopLevel == item.code
        //             ).map(res => res.ch_value)
        //         );
        //     }
        //   },
          {
            title: this.$t('PB_Vacancies_Position'),/* 空岗职位 */
            key: "jobName",
            align: "center",
            minWidth: 200
          },{
            title: 'Band',/* Band */
            key: "hcmBand",
            align: "center",
            minWidth: 200,
            render: (h, params) => {
                return h(
                "span",
                this.Band &&
                    this.Band.filter(
                    item => params.row.hcmBand == item.code
                    ).map(res => res.ch_value)
                );
            }
          },{
            title: this.$t('Position_Title_Chinese'),/* 职务描述（中文） */
            key: "positionCTitle",
            align: "center",
            minWidth: 200
          }, {
            title: this.$t('Position_Title_English'),/* 职务描述（英文） */
            key: "positionETitle",
            align: "center",
            minWidth: 200
          }, {
            title: this.$t('PB_Line_Manager'),/* 汇报人 */
            key: "reportName",
            align: "center",
            minWidth: 200
          }, {
            title: this.$t('BU'),/* 业务单元 */
            key: "businessUnit",
            align: "center",
            minWidth: 200,
            render: (h, params) => {
                return h(
                "span",
                this.businessUnitList &&
                    this.businessUnitList.filter(
                    item => params.row.businessUnit == item.code
                    ).map(res => res.ch_value)
                );
            }
          },{
            title: this.$t('Department'),/*大区 */
            key: "department",
            align: "center",
            minWidth: 200,
            render: (h, params) => {
                return h(
                "span",
                this.departmentList &&
                    this.departmentList.filter(
                    item => params.row.department == item.code
                    ).map(res => res.ch_value)
                );
            }
          },{
            title: this.$t('Funciton'),/* 职能 */
            key: "postFun",
            align: "center",
            minWidth: 200,
            render: (h, params) => {
                return h(
                "span",
                this.functionList &&
                    this.functionList.filter(
                    item => params.row.postFun == item.code
                    ).map(res => res.ch_value)
                );
            }
          },{
            title: this.$t('Position'),/* 职位 */
            key: "positionCodeName",
            align: "center",
            minWidth: 200
          },{
          title: this.$t('Action'),/* 操作 */
          slot: "action1",
          align: "center",
          minWidth: 140,
          fixed:'right'
        }
      ]
    },
    lang(){
      return this.$store.getters.selectLangeData
    },
  },
  created(){
    // this.getData()
    this.getListData()
  },
  
  methods: {
    getData(){
        this.loading=true
        axios.post("/TalentInventory/selectMeetingNullJobList", {id:this.id,...this.pageInfo,...this.modalFormItem}).then((res) => {
            this.loading=false
            if (res) {
                this.modelData=res.data
                this.nullJobNum=res.nullJobNum
            }
        })
    },
    getListData(){
        axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
            if (res) {
                this.yesOrNo=res.YesOrNo
                this.businessUnitList=res.businessUnitList
                this.departmentList=res.departmentList
                this.functionList=res.functionList
                this.Band=res.Band
            }
        })
    },
    
  
    pageChange(val){
        this.pageInfo.pageNo = val;
        this.getData()
    },
    handleConfirm(){
      // this.modelColumns.splice(0, 1);
      this.modal=false
       this.$emit('jobSelectList',JSON.parse(JSON.stringify(this.modelData)))
      this.$nextTick(() => {
        this.$refs.selectiona.selectAll(false);
      })
    },
    handleCancle(){
      // this.modelColumns.splice(0, 1);
      this.modal=false
      this.$nextTick(() => {
        this.$refs.selectiona.selectAll(false);
      })
    },
    
    addJob(){
        this.$refs.JobModal.jobmodal=true
        this.$refs.JobModal.edit=false
        this.$refs.JobModal.id=this.id
        // this.$refs.JobModal.jobFormItem.nullJobSerialnumberList=[...this.jobselectList]
    },
    jobSave(item){
        this.getData()
        // this.modelData.push(item)
        // this.nullJobNum=this.modelData.length
    },
    editItem(item,index){
        this.index=index
        this.$refs.JobModal.id=this.id
        this.$refs.JobModal.jobmodal=true
        this.$refs.JobModal.jobFormItem=JSON.parse(JSON.stringify(item))
         this.$refs.JobModal.edit=true
         this.$refs.JobModal.tIndex=index
    },
    deleteItem(item,index){
        this.$Modal.confirm({
            title: this.$t('Are_you_sure_to_delete'),
            onOk: () => {
                 axios.post("/successorInfo/deleteSuccessionInfo", item).then((res) => {
                    if (res) {
                        this.modelData=res.data
                        this.nullJobNum=res.nullJobNum
                        this.getData()
                    }
                })
            }
        })
        
        // this.modelData.splice(index,1)
        // this.nullJobNum=this.modelData.length
    },
    jobEdit(item){
        // this.modelData[this.index]=item
        this.getData()
    },
    pageSizeChange(val){
      this.pageInfo.pageSize=val
      this.getData()
    },
    handleReset(){
      this.modalFormItem={}
      // this.pageInfo.pageNo=1
      // this.getData()
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/PeopleBoardComponents/PDJob.vue